import React from 'react';
import { MainContent } from '@layout';
import { Button } from '@input';
import { H2, H3 } from '@heading';
import styles from './Intro.module.scss';
import usePageVisible from '@hooks/usePageVisible';
import Nucleus from './nucleus.svg';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';

export default function Intro() {
  const [pageVisible] = usePageVisible();
  const [ref, inView] = useInView();

  return (
    <MainContent
      contentClassName={styles.wrapper}
      ref={ref}
    >
      <div className={styles.text}>
        <H2>What we do at the lab</H2>
        <p>
          Our team uses <strong>clumped isotopes</strong> and other
          innovative tools to address fundamental questions about the
          dynamics of climate change past and future.
        </p>
        <p>
          We also explore questions about the oceans, earth systems
          history, geochemistry, geobiology, and sedimentary geology.
        </p>

        <H3>What are clumped isotopes?</H3>
        <p>
          This refers to the occurance of multiple rare isotope
          substitutions in molecules. We use clumped isotopes in carbonates
          as a tool to address pressing questions about earth systems,
          geochemistry, geobiology and sedimentary geology.
        </p>
        <p>
          Although clumped isotopes are the primary tool our group uses, we
          also apply other geochemical proxies including elemental and
          stable isotopic ratios of carbonate minerals. Visit our research
          page to learn more about the exciting work we do at the lab.
        </p>

        <Button
          icon="atom"
          className={styles.button}
        >
          Learn about our research
        </Button>
      </div>
      <div
        aria-hidden="true"
        className={classNames(styles.molecule, {
          [styles.paused]: !pageVisible || !inView
        })}
      >
        <Nucleus />
        <div className={classNames(styles.ring, styles.inner)} />
        <div className={classNames(styles.ring, styles.outer)} />
      </div>
    </MainContent>
  );
}
